export default {
  addedToCart: {
    id: 'product_add_to_cart_page_desktop_title',
    defaultMessage: 'Added to cart',
  },
  addedToCartItems: {
    id: 'product_add_to_cart_page_mobile_title',
    defaultMessage: `{count, plural,
      one {item added to cart}
      other {# items added to cart}
    }`,
  },
}
